import { useEffect, useRef, useState } from 'react';

import { isBrowser } from '../helpers';

interface IProps {
  threshold?: number;
  containerId?: string;
}

export function useScrollHeader({ threshold = 60, containerId = 'root' }: IProps = {}) {
  const [showHeader, setShowHeader] = useState(true);
  const lastScrollYRef = useRef(0);

  useEffect(() => {
    const container = isBrowser() ? document.getElementById(containerId) : null;

    const handleScroll = () => {
      if (container) {
        const currentScrollY = container.scrollTop;

        if (currentScrollY > lastScrollYRef.current && currentScrollY > threshold) {
          setShowHeader(false);
        } else {
          setShowHeader(true);
        }

        lastScrollYRef.current = currentScrollY;
      }
    };

    container?.addEventListener('scroll', handleScroll);

    return () => {
      container?.removeEventListener('scroll', handleScroll);
    };
  }, [containerId, threshold]); // no lastScrollY here

  return { showHeader, lastScrollY: lastScrollYRef.current };
}
